import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 * Use the raw response from the http repository to create an Ad Type Value Object.
 */
export class FromAdDetailsRawDataToAdTypeValueObjectMapper extends Mapper {
  constructor({adTypeValueObjectFactory, config}) {
    super()

    this._config = config
    this._adTypeValueObjectFactory = adTypeValueObjectFactory
  }

  map = async rawData => {
    const {ad} = rawData

    const {category = {}} = ad

    return this._adTypeValueObjectFactory({
      category1Id: category.category1Id,
      category2Id: category.category2Id,
      category3Id: category.category3Id,
      offerTypeId: ad.offerTypeId
    })
  }
}
